import React from 'react';
import './../App.css';
import './index.css';
import '../index.css';
import { Label20, Label14, Label28 } from './../components';
import { uploadStatusDateFormat } from '../utils/Helper'
import { API_URL, NOTIFICATION_ENUM } from '../utils/Constants';

export const NotificationHistoryDetail = ({ item, onBack }) => {
    const iconCss = item.notificationCategoryEnum === NOTIFICATION_ENUM.STUDENT ? "studentNotificationIcon" : "schoolNotificationIcon";

    const statusCss = item.filePath ? { color: '#009730', cursor: 'pointer' } : {color: '#FAA13C'};
    // const statusCss = item.filePath ? { color: '#6d758e', textDecoration: "underline", cursor: 'pointer' } : {color: '#6d758e'};
    const onStatusClick = (e) => {
        if (item.filePath) {
            e.stopPropagation();
            //window.open(item.filePath, '_blank');
            const authCode = localStorage.getItem("bearer");
            const fileName = item.filePath.split("/")[4];
            const url = API_URL.DOWNLOAD_DELIVERY_STATUS_EXCEL_FILE+"?fileName="+fileName;
            fetch(url, {
            method: 'POST',
            headers: {
                'Authorization': authCode,
                'Accept': 'application/json',
            }
            })        
            .then(response => {            
            return response.blob();
            })
            .then(blob => {
                var url = window.URL.createObjectURL(blob);
                var a = document.createElement('a');
                a.href = url;
                a.download = fileName;
                document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox		
                a.click();
                a.remove();  //afterwards we remove the element again         		
            })
            .catch(err => alert(err));
        }
    }
    // const typeName = item.notificationCategoryEnum === NOTIFICATION_ENUM.STUDENT ? "Student" : "School";
    let typeName = "All School";
    if (item.notificationCategoryEnum === NOTIFICATION_ENUM.STUDENT) typeName = "Student ID";
    if (item.notificationCategoryEnum === NOTIFICATION_ENUM.SCHOOL_CUSTOM) typeName = "Grades & Divisions";
    
    let recepient = "To: All Grades & Division";
    if (item.notificationCategoryEnum === NOTIFICATION_ENUM.STUDENT) {
        recepient = "To: ";
        const recipientList = item.pushNotificationConstructRecipients.studentMcBeneficiaryIdList;
        if (recipientList && recipientList.length > 0) {
            recipientList.forEach((value, index) => {
                const separator = index === 0 ? "" : ", ";
                recepient = recepient + separator + value;
            });
        }
    } else if (item.notificationCategoryEnum === NOTIFICATION_ENUM.SCHOOL_CUSTOM) {
        recepient = "To: ";
        const recipientList = item.pushNotificationConstructRecipients.gradeDivisionMapList;
        if (recipientList && recipientList.length > 0) {
            recipientList.forEach((item, index) => {
                const separator = index === 0 ? "" : ", ";
                const division = item.strDivision ? ", "+item.strDivision : "";
                recepient = recepient + separator + item.strGrade+division;
            })
        }
    }

    return (
        <div>
            <div className="divRow" style={{ alignItems: 'center' }}>
                <div className="backIcon" style={{ cursor: 'pointer' }} onClick={onBack} />
                <Label28 bold>View Notification</Label28>
            </div>
            <label className="label12" style={{ color: '#6d758e', marginLeft: 50, wordBreak: "break-word" }}>Notifications &gt; History &gt; {item.strSubject}</label>
            <div style={{ height: 16 }} />
            <div className="skiplyTabPageContainer">
                <div style={{ margin: 24, marginTop: 32 }}>
                    <label className="label20" style={{ wordBreak: "break-word" }}>{item.strSubject}</label>
                    <div />
                    <label className="label12" style={{ color: '#6d758e' }}>{typeName}</label>
                    <div style={{ height: 16 }} />

                    <div className="divRow" style={{ justifyContent: 'space-between' }}>
                        <div className="divRow" style={{ alignItems: 'center', width: "75%" }}>
                            <div className={iconCss} />
                            <div style={{ width: 16 }} />
                            <div style={{ width: '90%' }}>
                                <label className="label14" style={{ fontWeight: '600', width: 150, margin: 0, whiteSpace: 'nowrap', display: 'inline' }}>{item.createdBy}</label>
                                <div />
                                <label className="label12" style={{ color: '#6d758e' }}>{recepient}</label>
                            </div>
                        </div>
                        {/* <label className="label12" style={{ color: '#6d758e', margin: 0 }}>{uploadStatusDateFormat(item.createdOn)}</label> */}
                        <div>
                            <label className="label12" style={{ color: '#6d758e', margin: 0 }}>{uploadStatusDateFormat(item.createdOn)}</label>
                            <div />
                            <label className="label12" style={{ color: '#6d758e', width: '100%', textAlign: 'end' }}>{``}
                                <label className="label12" style={statusCss} onClick={onStatusClick}>{item.status}</label>
                            </label>
                        </div>
                    </div>
                    <div style={{ height: 32 }} />
                    <div style={{ marginLeft: 52, width: '70%', paddingBottom: 20 }}>
                        <label className="label14" style={{ wordBreak: "break-word" }}>{item.strMessage}</label>
                    </div>
                </div>
            </div>
        </div>
    );
}